<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4463_13698)">
      <path
        d="M14.6667 11.2802V13.2802C14.6674 13.4659 14.6294 13.6497 14.555 13.8198C14.4806 13.9899 14.3715 14.1426 14.2347 14.2681C14.0979 14.3937 13.9364 14.4892 13.7605 14.5487C13.5846 14.6082 13.3982 14.6303 13.2133 14.6136C11.1619 14.3907 9.19133 13.6897 7.46 12.5669C5.84922 11.5433 4.48356 10.1777 3.46 8.56689C2.33332 6.8277 1.63216 4.84756 1.41333 2.78689C1.39667 2.60254 1.41858 2.41673 1.47767 2.24131C1.53675 2.06589 1.63171 1.90469 1.75651 1.76797C1.88131 1.63126 2.0332 1.52203 2.20253 1.44724C2.37185 1.37245 2.55489 1.33374 2.74 1.33356H4.74C5.06354 1.33038 5.3772 1.44495 5.62251 1.65592C5.86782 1.86689 6.02805 2.15986 6.07333 2.48023C6.15775 3.12027 6.3143 3.74871 6.54 4.35356C6.6297 4.59218 6.64911 4.8515 6.59594 5.10081C6.54277 5.35012 6.41924 5.57897 6.24 5.76023L5.39333 6.60689C6.34237 8.27592 7.7243 9.65786 9.39333 10.6069L10.24 9.76023C10.4213 9.58099 10.6501 9.45746 10.8994 9.40429C11.1487 9.35112 11.4081 9.37053 11.6467 9.46023C12.2515 9.68593 12.88 9.84248 13.52 9.92689C13.8438 9.97258 14.1396 10.1357 14.351 10.3852C14.5624 10.6348 14.6748 10.9533 14.6667 11.2802Z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4463_13698">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
